webpackJsonp([3],{

/***/ "6510":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "9oV+":
/***/ (function(module, exports, __webpack_require__) {

/* eslint-disable */
var icon = __webpack_require__("0QuU");
icon.register({
  'icon_menu-close': {
    width: 16,
    height: 16,
    viewBox: '0 0 50 50',
    data: '<path pid="0" d="M7.719 6.281L6.28 7.72 23.563 25 6.28 42.281l1.44 1.439L25 26.437 42.281 43.72l1.438-1.438L26.437 25 43.72 7.719 42.28 6.28 25 23.563z"/>'
  }
});

/***/ }),

/***/ "Dh98":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vue-read-more/components/ReadMoreComponent.vue
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var ReadMoreComponent = ({
	props: {
		moreStr: {
			type: String,
			default: 'read more'
		},
		lessStr: {
			type: String,
			default: ''
		},
		text: {
			type: String,
			required: true
		},
		link: {
			type: String,
			default: '#'
		},
		maxChars: {
			type: Number,
			default: 100
		}
	},

	data: function data() {
		return {
			isReadMore: false
		};
	},


	computed: {
		formattedString: function formattedString() {
			var val_container = this.text;

			if (!this.isReadMore && this.text.length > this.maxChars) {
				val_container = val_container.substring(0, this.maxChars) + '...';
			}

			return val_container;
		}
	},

	methods: {
		triggerReadMore: function triggerReadMore(e, b) {
			if (this.link == '#') {
				e.preventDefault();
			}
			if (this.lessStr !== null || this.lessStr !== '') this.isReadMore = b;
		}
	}
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3ca2a6d4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vue-read-more/components/ReadMoreComponent.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',{domProps:{"innerHTML":_vm._s(_vm.formattedString)}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.text.length > _vm.maxChars),expression:"text.length > maxChars"}]},[_c('a',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isReadMore),expression:"!isReadMore"}],attrs:{"href":_vm.link,"id":"readmore"},on:{"click":function($event){_vm.triggerReadMore($event, true)}}},[_vm._v(_vm._s(_vm.moreStr))]),_vm._v(" "),_c('a',{directives:[{name:"show",rawName:"v-show",value:(_vm.isReadMore),expression:"isReadMore"}],attrs:{"href":_vm.link,"id":"readmore"},on:{"click":function($event){_vm.triggerReadMore($event, false)}}},[_vm._v(_vm._s(_vm.lessStr))])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var components_ReadMoreComponent = (esExports);
// CONCATENATED MODULE: ./node_modules/vue-read-more/components/ReadMoreComponent.vue
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  ReadMoreComponent,
  components_ReadMoreComponent,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var vue_read_more_components_ReadMoreComponent = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/vue/dist/vue.esm.js
var vue_esm = __webpack_require__("7+uW");

// EXTERNAL MODULE: ./src/compiled-icons/index.js
var compiled_icons = __webpack_require__("bJAA");
var compiled_icons_default = /*#__PURE__*/__webpack_require__.n(compiled_icons);

// EXTERNAL MODULE: ./node_modules/axios/index.js
var axios = __webpack_require__("mtWM");
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/global/Header.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var Header = ({
  data: function data() {
    return {
      menuOpen: false,
      profileOpen: false,
      profileData: {},
      props: ['menu']
    };
  },
  mounted: function mounted() {
    this.getProfileData();
  },


  methods: {
    toggleMenu: function toggleMenu() {
      this.menuOpen = !this.menuOpen;
      if (this.menuOpen === false) {
        this.profileOpen = false;
      }
    },
    toggleProfile: function toggleProfile() {
      this.profileOpen = !this.profileOpen;
    },
    closeMenu: function closeMenu() {
      if (this.menuOpen === true) {
        this.menuOpen = !this.menuOpen;
      }
    },
    getProfileData: function getProfileData() {
      var _this = this;

      axios_default.a.get("https://annafitzon.de/wp" + '/wp-json/acf/v3/options/general').then(function (res) {
        _this.profileData = res.data.acf;
      }).catch(function (e) {
        console.log(e);
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-11805687","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/global/Header.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{attrs:{"role":"banner"}},[_c('nav',{staticClass:"navigation navigation--main",attrs:{"aria-label":"site"}},[_c('h1',{staticClass:"logo"},[_c('router-link',{attrs:{"to":"/"},nativeOn:{"click":function($event){return _vm.closeMenu($event)}}},[_vm._v("Anna Fitzon"),_c('br'),_vm._v("Kommunikationsdesign")])],1),_c('button',{staticClass:"visible-xs",attrs:{"aria-expanded":_vm.menuOpen ? 'true' : 'false'},on:{"click":_vm.toggleMenu}},[_c('svgicon',{attrs:{"name":_vm.menuOpen ? 'icon_menu-close' : 'icon_menu'}})],1),_c('ul',{staticClass:"menu",attrs:{"aria-expanded":_vm.menuOpen ? 'true' : 'false'}},[_c('li',{staticClass:"menu__item menu__item--smile"},[_c('a',{attrs:{"aria-expanded":_vm.profileOpen ? 'true' : 'false'},on:{"click":_vm.toggleProfile}},[_vm._v("About")]),(_vm.profileData)?_c('div',{staticClass:"profile",attrs:{"aria-expanded":_vm.profileOpen ? 'true' : 'false'}},[_c('img',{attrs:{"src":_vm.profileData.profile_pic.url}}),_c('div',{staticClass:"profile__desc",domProps:{"innerHTML":_vm._s(_vm.profileData.profile_desc)}})]):_vm._e()]),_vm._m(0),_c('li',{staticClass:"menu__item menu__item--imprint"},[_c('router-link',{attrs:{"to":"impressum"},nativeOn:{"click":function($event){return _vm.closeMenu($event)}}},[_vm._v("Impressum")])],1),_c('li',{staticClass:"menu__item menu__item--privacy"},[_c('router-link',{attrs:{"to":"datenschutz"},nativeOn:{"click":function($event){return _vm.closeMenu($event)}}},[_vm._v("Datenschutz")])],1)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"menu__item menu__item--mail"},[_c('a',{attrs:{"title":"Mail an Anna schreiben","href":"mailto:info@annafitzon.de"}},[_vm._v("info@annafitzon.de")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var global_Header = (esExports);
// CONCATENATED MODULE: ./src/components/global/Header.vue
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  Header,
  global_Header,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_global_Header = (Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/global/BackToTop.vue
//
//
//
//
//
//



/* harmony default export */ var BackToTop = ({
  name: 'BackToTop',
  props: {
    visibleOffset: {
      type: [String, Number],
      default: 400
    }
  },
  data: function data() {
    return {
      visible: false
    };
  },
  created: function created() {
    var _this = this;

    var catchScroll = function catchScroll() {
      _this.visible = window.pageYOffset > parseInt(_this.visibleOffset);
    };
    window.smoothScroll = function () {
      var currentScroll = document.documentElement.scrollTop || document.body.scrollTop;
      if (currentScroll > 0) {
        window.requestAnimationFrame(window.smoothScroll);
        window.scrollTo(0, Math.floor(currentScroll - currentScroll / 5));
      }
    };
    window.onscroll = catchScroll;
  },

  methods: {
    backToTop: function backToTop() {
      window.smoothScroll();
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fab1f58e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/global/BackToTop.vue
var BackToTop_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"back-to-top--fade"}},[_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.visible),expression:"visible"}],staticClass:"back-to-top",on:{"click":_vm.backToTop}},[_c('svgicon',{attrs:{"name":"icon_arrow-up"}})],1)])}
var BackToTop_staticRenderFns = []
var BackToTop_esExports = { render: BackToTop_render, staticRenderFns: BackToTop_staticRenderFns }
/* harmony default export */ var global_BackToTop = (BackToTop_esExports);
// CONCATENATED MODULE: ./src/components/global/BackToTop.vue
var BackToTop_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var BackToTop___vue_template_functional__ = false
/* styles */
var BackToTop___vue_styles__ = null
/* scopeId */
var BackToTop___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var BackToTop___vue_module_identifier__ = null
var BackToTop_Component = BackToTop_normalizeComponent(
  BackToTop,
  global_BackToTop,
  BackToTop___vue_template_functional__,
  BackToTop___vue_styles__,
  BackToTop___vue_scopeId__,
  BackToTop___vue_module_identifier__
)

/* harmony default export */ var components_global_BackToTop = (BackToTop_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/App.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var App = ({
  name: 'app',

  data: function data() {
    return {
      menu: {
        open: false
      }
    };
  },


  components: {
    wpheader: components_global_Header,
    BackToTop: components_global_BackToTop
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7d099a64","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
var App_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('div',{staticClass:"container-fluid"},[_c('a',{staticClass:"sr-only",attrs:{"href":"#main"}},[_vm._v("Zum Hauptinhalt wechseln")]),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12 col-sm-4 col-md-3 fixed"},[_c('wpheader',_vm._b({},'wpheader',_vm.menu,false))],1),_c('main',{staticClass:"col-xs-12 col-sm-8 col-md-9",attrs:{"id":"main"}},[_c('transition',{attrs:{"name":"fade"}},[_c('router-view',{key:_vm.$route.path})],1)],1),_c('back-to-top',{attrs:{"text":"Top"}})],1)])])}
var App_staticRenderFns = []
var App_esExports = { render: App_render, staticRenderFns: App_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_App = (App_esExports);
// CONCATENATED MODULE: ./src/App.vue
function injectStyle (ssrContext) {
  __webpack_require__("6510")
}
var App_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var App___vue_template_functional__ = false
/* styles */
var App___vue_styles__ = injectStyle
/* scopeId */
var App___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var App___vue_module_identifier__ = null
var App_Component = App_normalizeComponent(
  App,
  selectortype_template_index_0_src_App,
  App___vue_template_functional__,
  App___vue_styles__,
  App___vue_scopeId__,
  App___vue_module_identifier__
)

/* harmony default export */ var src_App = (App_Component.exports);

// EXTERNAL MODULE: ./node_modules/vue-router/dist/vue-router.esm.js
var vue_router_esm = __webpack_require__("/ocq");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/pages/Homepage.vue
//
//
//
//
//
//
//
//
//



/* harmony default export */ var Homepage = ({
  name: 'Homepage',
  data: function data() {
    return {
      title: 'Anna Fitzon – Visuelle Kommunikation',
      projects: [],
      loading: true,
      slick: ''
    };
  },
  created: function created() {
    this.getProjects();
    document.title = this.title;
  },


  methods: {
    getProjects: function getProjects() {
      var _this = this;

      axios_default.a.get("https://annafitzon.de/wp" + '/wp-json/wp/v2/projects?per_page=100').then(function (response) {
        _this.loading = false;
        _this.projects = response.data;
      }).catch(function (e) {
        console.log(e);
      });
    }
  },

  components: {
    'list-projects': function listProjects() {
      return __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, "VD9i"));
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0d1d54ce","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/Homepage.vue
var Homepage_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"homepage"}},[_c('div',{staticClass:"loading",class:_vm.loading ? '' : 'loading--end'},[_c('div',{staticClass:"loading__dot"}),_c('div',{staticClass:"loading__dot"}),_c('div',{staticClass:"loading__dot"}),_c('div',{staticClass:"loading__dot"})]),_c('list-projects',{attrs:{"projects":_vm.projects}})],1)}
var Homepage_staticRenderFns = []
var Homepage_esExports = { render: Homepage_render, staticRenderFns: Homepage_staticRenderFns }
/* harmony default export */ var pages_Homepage = (Homepage_esExports);
// CONCATENATED MODULE: ./src/components/pages/Homepage.vue
var Homepage_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Homepage___vue_template_functional__ = false
/* styles */
var Homepage___vue_styles__ = null
/* scopeId */
var Homepage___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Homepage___vue_module_identifier__ = null
var Homepage_Component = Homepage_normalizeComponent(
  Homepage,
  pages_Homepage,
  Homepage___vue_template_functional__,
  Homepage___vue_styles__,
  Homepage___vue_scopeId__,
  Homepage___vue_module_identifier__
)

/* harmony default export */ var components_pages_Homepage = (Homepage_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/pages/Page.vue
//
//
//
//
//
//
//
//
//



/* harmony default export */ var Page = ({
  name: 'Page',
  data: function data() {
    return {
      title: '',
      post: [],
      loading: true,
      showPage: false
    };
  },
  created: function created() {
    this.getPost();
  },
  updated: function updated() {
    this.showPage = true;
  },


  methods: {
    getPost: function getPost() {
      var _this = this;

      var path = this.$route.path;
      axios_default.a.get("https://annafitzon.de/wp" + '/wp-json/wp/v2/pages/?slug=' + path.replace(/^\/|\/$/g, '')).then(function (response) {
        _this.post = response.data[0];
        _this.loading = false;

        if (_this.post === undefined) {
          _this.$router.push({ name: 'NotFound' });
        }
        document.title = _this.post.title.rendered;
      }).catch(function (e) {
        console.log(e);
      });
    }
  },

  components: {
    'single-post': function singlePost() {
      return __webpack_require__.e/* import() */(1).then(__webpack_require__.bind(null, "RNnx"));
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5de692ae","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/Page.vue
var Page_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"page"}},[_c('div',{staticClass:"loading",class:_vm.loading ? '' : 'loading--end'},[_c('div',{staticClass:"loading__dot"}),_c('div',{staticClass:"loading__dot"}),_c('div',{staticClass:"loading__dot"}),_c('div',{staticClass:"loading__dot"})]),(_vm.loading === false)?_c('div',{staticClass:"page",class:{'page--show': _vm.showPage}},[_c('single-post',{attrs:{"post":_vm.post}})],1):_vm._e()])}
var Page_staticRenderFns = []
var Page_esExports = { render: Page_render, staticRenderFns: Page_staticRenderFns }
/* harmony default export */ var pages_Page = (Page_esExports);
// CONCATENATED MODULE: ./src/components/pages/Page.vue
var Page_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Page___vue_template_functional__ = false
/* styles */
var Page___vue_styles__ = null
/* scopeId */
var Page___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Page___vue_module_identifier__ = null
var Page_Component = Page_normalizeComponent(
  Page,
  pages_Page,
  Page___vue_template_functional__,
  Page___vue_styles__,
  Page___vue_scopeId__,
  Page___vue_module_identifier__
)

/* harmony default export */ var components_pages_Page = (Page_Component.exports);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c18d4ac8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/404.vue
var _04_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h1',[_vm._v("404")])}
var _04_staticRenderFns = []
var _04_esExports = { render: _04_render, staticRenderFns: _04_staticRenderFns }
/* harmony default export */ var _04 = (_04_esExports);
// CONCATENATED MODULE: ./src/components/pages/404.vue
var _04_normalizeComponent = __webpack_require__("VU/8")
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var _04___vue_template_functional__ = false
/* styles */
var _04___vue_styles__ = null
/* scopeId */
var _04___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var _04___vue_module_identifier__ = null
var _04_Component = _04_normalizeComponent(
  __vue_script__,
  _04,
  _04___vue_template_functional__,
  _04___vue_styles__,
  _04___vue_scopeId__,
  _04___vue_module_identifier__
)

/* harmony default export */ var pages_404 = (_04_Component.exports);

// CONCATENATED MODULE: ./src/router/index.js






vue_esm["a" /* default */].use(vue_router_esm["a" /* default */]);

/* harmony default export */ var router = (new vue_router_esm["a" /* default */]({
  mode: 'history',
  routes: [{
    name: 'Homepage',
    path: '/',
    component: components_pages_Homepage
  }, {
    name: 'Impressum',
    path: '/impressum',
    component: components_pages_Page
  }, {
    name: 'Datenschutz',
    path: '/datenschutz',
    component: components_pages_Page
  }, {
    name: 'NotFound',
    path: '*',
    component: pages_404
  }]
}));
// EXTERNAL MODULE: ./node_modules/vue-svgicon/dist/index.js
var dist = __webpack_require__("0QuU");
var dist_default = /*#__PURE__*/__webpack_require__.n(dist);

// EXTERNAL MODULE: ./node_modules/vue-read-more/index.js + 1 modules
var vue_read_more = __webpack_require__("uIjV");

// EXTERNAL MODULE: ./node_modules/intersection-observer/intersection-observer.js
var intersection_observer = __webpack_require__("p3C9");
var intersection_observer_default = /*#__PURE__*/__webpack_require__.n(intersection_observer);

// EXTERNAL MODULE: ./node_modules/vue-clazy-load/dist/vue-clazy-load.js
var vue_clazy_load = __webpack_require__("MYII");
var vue_clazy_load_default = /*#__PURE__*/__webpack_require__.n(vue_clazy_load);

// CONCATENATED MODULE: ./src/main.js
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.








vue_esm["a" /* default */].config.productionTip = false;

vue_esm["a" /* default */].use(intersection_observer_default.a);
vue_esm["a" /* default */].use(vue_clazy_load_default.a);

vue_esm["a" /* default */].use(dist, {
  tagName: 'svgicon'
});

vue_esm["a" /* default */].use(vue_read_more["a" /* default */]);

/* eslint-disable no-new */
new vue_esm["a" /* default */]({
  el: '#app',
  router: router,
  template: '<App/>',
  components: { App: src_App }
});

/***/ }),

/***/ "bJAA":
/***/ (function(module, exports, __webpack_require__) {

/* eslint-disable */
__webpack_require__("sKkd");
__webpack_require__("9oV+");
__webpack_require__("g836");

/***/ }),

/***/ "g836":
/***/ (function(module, exports, __webpack_require__) {

/* eslint-disable */
var icon = __webpack_require__("0QuU");
icon.register({
  'icon_menu': {
    width: 16,
    height: 16,
    viewBox: '0 0 50 50',
    data: '<path pid="0" d="M0 9v2h50V9zm0 15v2h50v-2zm0 15v2h50v-2z"/>'
  }
});

/***/ }),

/***/ "sKkd":
/***/ (function(module, exports, __webpack_require__) {

/* eslint-disable */
var icon = __webpack_require__("0QuU");
icon.register({
  'icon_arrow-up': {
    width: 16,
    height: 16,
    viewBox: '0 0 50 50',
    data: '<path pid="0" d="M25 7.656l-.72.688L13.407 19.25c-.297.242-.433.63-.347 1.004a1 1 0 001.752.402L24 11.47V41c-.004.36.184.695.496.88.313.18.695.18 1.008 0 .312-.185.5-.52.496-.88V11.47l9.188 9.186c.242.297.628.434 1.003.348a1.003 1.003 0 00.404-1.754L25.72 8.344z"/>'
  }
});

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.9ad68f1abac4b0077df3.js